/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PercentOfListPrice
 */
export interface PercentOfListPrice {
}

/**
 * Check if a given object implements the PercentOfListPrice interface.
 */
export function instanceOfPercentOfListPrice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PercentOfListPriceFromJSON(json: any): PercentOfListPrice {
    return PercentOfListPriceFromJSONTyped(json, false);
}

export function PercentOfListPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PercentOfListPrice {
    return json;
}

export function PercentOfListPriceToJSON(value?: PercentOfListPrice | null): any {
    return value;
}

